<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M38.3371 12.4422L38.3442 12.4464C38.4401 12.5032 38.4999 12.6072 38.5 12.7207V38.1811C38.5 38.2656 38.4664 38.3468 38.4065 38.4067C38.3466 38.4666 38.2657 38.5 38.1816 38.5H1.81839C1.73429 38.5 1.65337 38.4666 1.59347 38.4067C1.53356 38.3467 1.5 38.2656 1.5 38.1811V12.7323C1.5031 12.6207 1.56461 12.5186 1.66231 12.4637L1.68098 12.4532L1.69934 12.4421L19.8662 1.53885C19.9126 1.51345 19.9647 1.5 20.0182 1.5C20.0716 1.5 20.124 1.51351 20.1703 1.53886L38.3371 12.4422Z" :stroke="fill" stroke-width="3"/>
    <rect height="6" :stroke="fill" stroke-width="2" width="14" x="13" y="17"/>
    <rect :fill="fill" height="6" width="2" x="19" y="24"/>
    <path d="M26 16C26 15.4477 26.4477 15 27 15C27.5523 15 28 15.4477 28 16V24C28 24.5523 27.5523 25 27 25C26.4477 25 26 24.5523 26 24V16Z" :fill="fill"/>
    <path d="M12 16C12 15.4477 12.4477 15 13 15C13.5523 15 14 15.4477 14 16V24C14 24.5523 13.5523 25 13 25C12.4477 25 12 24.5523 12 24V16Z" :fill="fill"/>
    <rect :fill="fill" height="4" rx="1" transform="rotate(90 22 29)" width="2" x="22" y="29"/>
  </svg>

</template>

<script>
export default {
  name: 'AuctionHouse',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
